export const entrepriseKeys = {
  all: ["entreprise"] as const,
  details: () => [...entrepriseKeys.all, "detail"],
  detail: (idEntreprise: string) => [...entrepriseKeys.details(), idEntreprise],
};
